var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"green-filter pointer-event invert",attrs:{"src":require("@/assets/icons/speakerphone.svg"),"height":"20px"},on:{"click":function($event){return _vm.startSpeechToTxt(_vm.tts)}}})}
var staticRenderFns = []

export { render, staticRenderFns }